import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setSearchModalDisplay, } from '../../../actions/filterSearch';
import Modal from 'react-modal';
import FilterSlider from './FilterSlider';
import close from '../../../images/icons/closedetail.png';



const FilterModal = () => {
  const dispatch = useDispatch();
  const { searchModalDisplay } = useSelector(state => state.filterSearch);
  const { selectedListing } = useSelector(state => state.filterSearch);
  const detailsClose = () => dispatch(setSearchModalDisplay(undefined));
  return (
    <Modal isOpen={searchModalDisplay}
      onRequestClose={detailsClose}
      ariaHideApp={false}
      contentLabel="lifecarefront.com"
      closeTimeoutMS={400}
      className='filter-search-group-modal'>
        <div className='close-detail-div'>
          <img onClick={() => {
            dispatch(setSearchModalDisplay(undefined));
          }} src={close} className='closedetail' alt='lifecarefront.com' 
             title='lifecarefront.com | Life Care Properties | Listings' />
        </div>
        <FilterSlider />
        <div className='listing-description-modal-div'>
          <p className='listing-description-modal-p'>{selectedListing.description}</p>
          <button onClick={() => {
             typeof(selectedListing.title) === "undefined" ?
             window.location.href = `https://wa.me/2347070019934?text=${`Service needed LifeCare`}` :
             window.location.href = `https://wa.me/2347070019934?text=${`Welcome to LifeCare Front
             Your last check:
             Property-Type: ${selectedListing.title}
             Property-Location: ${selectedListing.areaName}, ${selectedListing.city}, ${selectedListing.state}
             listing No: ${selectedListing.productRef}`}`; 
           }
           }  className='adsmodal-reachout'>Reach Out for Details</button>
        </div>
      </Modal>
  )
};


export default FilterModal;